import React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogDescription,
  DialogFooter,
  DialogFooterSpacer,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from '../../../components/Dialog'
import { RejectMergeDialogViewModel } from './RejectMergeDialogViewModel'

interface Props {
  vm: RejectMergeDialogViewModel
}

export default observer(function MergeAccountsDialog({ vm }: Props) {
  return (
    <Dialog showing={vm.showing} onClose={vm.close}>
      <DialogHeader bordered>
        <DialogIllustration
          src={require('assets/images/img_confirm-action.svg')}
          alt="Illustration of a confused person with a question mark bubble above their head"
        />
        <DialogTitle>You're about to decline this merge request</DialogTitle>
        <DialogDescription>
          If you decline, we will notify{' '}
          <strong>{vm.customerDisplayName}</strong> that we will take no further
          action against their account.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter bordered>
        <DialogFooterSpacer />
        <DialogButtonGroup>
          <DialogButton disabled={vm.reject.pending} onClick={vm.close}>
            Close
          </DialogButton>
          <DialogButton
            disabled={vm.reject.pending}
            type="danger"
            onClick={vm.reject}
            loading={vm.reject.pending}
          >
            Decline Merge
          </DialogButton>
        </DialogButtonGroup>
      </DialogFooter>
    </Dialog>
  )
})
